<script setup lang="ts">
import { applyUpdate, needsRefresh } from '@/lib/pwa'
</script>

<template>
  <div v-if="needsRefresh" role="status" class="toast toast-center toast-bottom z-50">
    <div class="alert">
      <span>A new version is ready.</span>
      <button class="btn btn-sm btn-primary" @click="applyUpdate">Reload</button>
      <button class="btn btn-sm btn-ghost" @click="needsRefresh = false">Later</button>
    </div>
  </div>
</template>
